import { render } from "./NDoubleButton.vue?vue&type=template&id=6acc76a7&ts=true"
import script from "./NDoubleButton.vue?vue&type=script&lang=ts"
export * from "./NDoubleButton.vue?vue&type=script&lang=ts"

import "./NDoubleButton.vue?vue&type=style&index=0&id=6acc76a7&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__